import ReactECharts from "echarts-for-react";

export default function CompositionCharts({ barChartApiData, pieChartApiData }) {
    // Filtramos las agrupaciones para excluir valores negativos
    const filteredAgrupaciones = pieChartApiData.filter((agrupacion) => agrupacion.porcentaje >= 0);
    const filteredInstrumentos = barChartApiData
        .filter((instrumento) => instrumento.porcentaje >= 0)
        .sort((a, b) => b.porcentaje - a.porcentaje); // Ordenamos de menor a mayor porcentaje

    // Preparando los datos para el gráfico de pastel.
    const pieChartData = filteredAgrupaciones.map((agrupacion) => ({
        value: agrupacion.porcentaje, // Convertimos a porcentaje
        name: agrupacion.descripcion,
    }));

    // Preparando los datos para el gráfico de barras, ya ordenados.
    const yAxisDataBar = filteredInstrumentos.map((item) => item.descripcion);
    const seriesDataBar = filteredInstrumentos.map((item) => item.porcentaje); // Convertido a porcentaje y formateado.

    const pieChartOptions = {
        title: {
            text: "Composición de la Cartera",
            left: "center",
            top: "0",
            textStyle: {
                color: "#333",
                fontStyle: "normal",
                fontWeight: "bold",
                fontFamily: "Arial",
                fontSize: 16,
            },
        },
        tooltip: {
            trigger: "item",
            formatter: "{b}: {c}%",
        },
        series: [
            {
                name: "Composición",
                type: "pie",
                data: pieChartData,
                radius: ["40%", "70%"],
            },
        ],
    };

    const barChartOptions = {
        grid: { left: 180 },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow", // Indicador del hover.
            },
        },
        xAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
        },
        yAxis: {
            type: "category",
            data: yAxisDataBar,
        },
        series: [
            {
                type: "bar",
                data: seriesDataBar,
            },
        ],
    };

    return (
        <div className="cot-composition-charts">
            <div className="chart-1">
                <ReactECharts option={pieChartOptions} />
            </div>

            <div className="chart-2">
                <ReactECharts option={barChartOptions} />
            </div>
        </div>
    );
}
